import styled from 'styled-components';

export const LeftBlockMainWrap = styled.div(
    props => `
        width: 70%;
        display: flex;
        flex-direction: column;
        padding-right: ${props.theme.spacing.large.l20};
    `
);

export const LeftBlockOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.white.base};
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 3px 2px -2px rgba(0, 0, 0, 0.07), 0 1px 5px 0 rgba(74, 74, 74, 0.2), 0 2px 2px 0 rgba(74, 74, 74, 0.2);
        margin-top: ${props.theme.spacing.large.l20};
    `
);

